import { HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ENavigationErrorType } from '../model/enum/navigation-error-type';
import { ENavigationRoute } from '../model/enum/navigation-route';

import { CoreData } from '../tools/core-data/core-data';
import { Message } from '../tools/http/message';
import { MessageSeverity } from '../tools/http/message-severity';
import { CustomSnackBarComponent } from '../tools/ui/custom-snackbar/custom-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
export class BaseService {

    constructor(protected router: Router,
        protected coreData: CoreData,
        protected snackBar: MatSnackBar) {
    }

    protected getFingerPrintGuid() {
        const nav = window.navigator;
        // const screen = window.window.screen;
        let guid = nav.mimeTypes.length + '';
        guid += nav.userAgent.replace(/\D+/g, '');
        guid += nav.plugins.length;
        // guid += screen.height || '';
        // guid += screen.width || '';
        guid += screen.pixelDepth || '';

        return guid;
    }

    private get BasicAuthorization() {
        return 'Basic ' + this.coreData.Token;
    }

    private get BearerAuthorization() {
        if (!this.coreData.Token)
            return '';
        return 'Bearer ' + this.coreData.Token;
    }


    protected generateHeader() {

        const headers: HttpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Application': environment.appCode,
            'Scope': this.coreData.SelectedScopeCode ? this.coreData.SelectedScopeCode : '',
            'Authorization': this.BearerAuthorization
        });
        const options = { withCredentials: true, headers: headers };
        return options;
    }

    protected generateHeaderWithEvents() {

        const headers: HttpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Application': environment.appCode,
            'Scope': this.coreData.SelectedScopeCode ? this.coreData.SelectedScopeCode : '',
            'Authorization': this.BearerAuthorization
        });
        const options = { withCredentials: true, headers: headers};
        return options;
    }

    protected generateHeaderWithParameters(params: HttpParams) {

        const headers: HttpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Application': environment.appCode,
            'Scope': this.coreData.SelectedScopeCode ? this.coreData.SelectedScopeCode : '',
            'Authorization': this.BearerAuthorization
        });
        const options = { withCredentials: true, headers: headers, params };
        return options;
    }

    protected generateHeaderForFormData() {

        const headers: HttpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Application': environment.appCode,
            'Scope': this.coreData.SelectedScopeCode ? this.coreData.SelectedScopeCode : '',
            'Authorization': this.BearerAuthorization
        });
        const options = { withCredentials: true, headers: headers, reportProgress: true };
        return options;
    }

    protected generateHeaderForFileDownload() {

        const headers: HttpHeaders = new HttpHeaders({
            'Accept': 'text/plain, */*',
            'Content-Type': 'application/json',
            'Authorization': this.BearerAuthorization,
            'Scope': this.coreData.SelectedScopeCode ? this.coreData.SelectedScopeCode : '',
            'Application': environment.appCode,
        });
        const options = { withCredentials: true, headers: headers, responseType: 'arraybuffer' as 'json', observe: 'response' as 'body' };
        return options;
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    protected handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
            let msg;
            switch (error.status) {
                case 400:
                    let json = '';
                    if (error.error instanceof ArrayBuffer) {
                        var enc = new TextDecoder();
                        const sl = enc.decode(error.error);
                        json = JSON.parse(sl);
                    } else {
                        json = error.error;
                    }
                    let txt = 'Mauvaise Action';
                    if (json && json.length > 0) {
                        txt = `${_.join(json, '\n')}`;
                    }
                    msg = new Message(txt, MessageSeverity.Error);
                    break;
                case 401:
                    msg = new Message('Puid ou mot de passe incorrect', MessageSeverity.Warning);
                    this.coreData.clearToken();
                    this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthenticated }]);
                    break;
                case 404:
                    msg = new Message('Aucune donnée trouvée', MessageSeverity.Error);
                    break;
                case 413:
                    msg = new Message('Quantité de donnée maximum depassée', MessageSeverity.Error);
                    break;
                case 429:
                    msg = new Message('Trop de requêtes ont été envoyées. Vous devez attendre ' + error.error, MessageSeverity.Error);
                    break;
                case 0:
                    msg = new Message('Pas de réseau', MessageSeverity.Error);
                    break;
                default:
                    msg = new Message(error.message, MessageSeverity.Error);
            }

            if (this.snackBar) {
                this.snackBar.openFromComponent(CustomSnackBarComponent, { data: msg, horizontalPosition: 'center' });
            }

            console.error(error); // log to console instead
            throw error;
            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
